module.exports = __webpack_public_path__ + "img/caprock_merchant.523f1bba.png";